module.exports = __webpack_public_path__ + "components/weather-icon/static/dayheavysnow-215e061cbdd6610685c2011928c8a77d.webp";